'use client';

import React from 'react';

import { Media } from '@/components/Media';
import { CMSLink } from '@/components/Link';
import { ArrowForLink } from '@/components/ArrowForLink';
import type { FeaturesGlobalWidget } from '@/payload-types';

export const WeCureList: React.FC<{
  title: string;
  features: FeaturesGlobalWidget['value'];
}> = ({ title, features }) => {
  return (
    <section className="v-margin" data-name="WeCureList">
      <div className="container">
        <h2 className="h2 mb-[43px] md:mb-[19px]">{title}</h2>

        <div className="grid grid-cols-3 gap-6 sm:gap-2 lg:grid-cols-1">
          {features?.map((i, idx) => (
            <CMSLink
              className="corners-sm group text-blue relative flex min-h-[152px] gap-4 border border-gray-500 p-[15px] sm:gap-3 sm:p-[11px] md:min-h-[104px]"
              key={i.id}
              {...i.link}
            >
              <div className="w-12 flex-none md:w-10">
                <Media resource={i.image} />
              </div>
              <div className="w-full max-w-[216px] pt-[7px] md:pt-[2px]">
                <h4 className="h5">{i.title}</h4>
                {i.description && <p className="mt-[7px]">{i.description}</p>}
              </div>
              <ArrowForLink className="absolute right-[23px] bottom-[23px] md:top-[11px] md:right-[11px] md:bottom-auto" />
            </CMSLink>
          ))}
        </div>
      </div>
    </section>
  );
};
